// extracted by mini-css-extract-plugin
export default {"codeWrapper":"rNVwP","code":"jCFYY","copy":"MR9ih"};